export default {
    contractors: [],
    contractorsTotal: 0,
    originalContractor: null,
}
